export const LOCAL_STORAGE_KEYS = {
  ambienteModo: "ambienteModo",
  companyId: "companyID",
  companyName: "companyName",
  menuExpand: "menu_expand",
  partners: "partners",
  persistUserguiding: "persist:userguiding",
  ugGuideEvents: "ug-guide-events",
  userApiToken: "userApiToken",
  userBearerToken: "userBearerToken",
  userEmail: "userEmail",
  userRefreshToken: "userRefreshToken",
  userType: "userType",
} as const;

export const getLocalStorage = (key: keyof typeof LOCAL_STORAGE_KEYS) => {
  return localStorage.getItem(LOCAL_STORAGE_KEYS[key]);
};

export const setLocalStorage = (
  key: keyof typeof LOCAL_STORAGE_KEYS,
  value: string,
) => {
  localStorage.setItem(LOCAL_STORAGE_KEYS[key], value);
};
